import * as React from 'react';

const PreloadFonts = ({ assetsUrl , fonts  })=>{
    if (!assetsUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, fonts.map((font)=>/*#__PURE__*/ React.createElement("link", {
            key: font,
            rel: "preload",
            as: "font",
            href: `${assetsUrl}/${font}.woff2`,
            type: "font/woff2",
            crossOrigin: "anonymous"
        })
    ));
};

export { PreloadFonts as default };
//# sourceMappingURL=PreloadFonts.js.map
